export const isKeyExist = <T extends object>(obj: T | undefined, key: keyof T): boolean =>
  obj !== undefined && key in obj && obj[key] !== undefined
